import { localDeviceNoun } from "../lib/utils";
import { Button } from "./ui/button";
import { CommandPanel } from "./ui/command";

interface CommandPaletteLocalFolderPanelProps {
  readonly isAddingSource: boolean;
  readonly onChooseFolder: () => void;
}

/**
 * The "local folder" step of Add Project. Pulled out of
 * `OpenCommandPaletteDialog` (apps/web/src/components/CommandPalette.tsx) —
 * the boundary is the whole `isLocalFolderView` `CommandPanel` branch;
 * `localDeviceNoun()` is a pure import with no component-scope closure, so it
 * is called directly here rather than threaded through as a prop.
 */
export function CommandPaletteLocalFolderPanel({
  isAddingSource,
  onChooseFolder,
}: CommandPaletteLocalFolderPanelProps) {
  return (
    <CommandPanel className="min-h-[160px] max-h-[min(28rem,70vh)] rounded-b-none">
      <div className="px-5 py-5">
        <p className="text-xs font-medium tracking-[0.08em] text-muted-foreground/60 uppercase">
          Local Folder
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          Pick a local folder. Work in this workspace runs on {localDeviceNoun()}.
        </p>
        <Button className="mt-4" size="sm" disabled={isAddingSource} onClick={onChooseFolder}>
          Choose Folder
        </Button>
      </div>
    </CommandPanel>
  );
}
